import { createSlice } from "@reduxjs/toolkit";
import { LOCAL_STORAGE_KEYS } from "utils/localStorageKeys";

const initialState: {
  mode: "collapsed" | "expanded";
  drawerVisibility: boolean;
} = {
  mode:
    (localStorage?.getItem(LOCAL_STORAGE_KEYS?.SIDE_BAR_MODE) as
      | "collapsed"
      | "expanded") || "collapsed",
  drawerVisibility: false,
};

const sideBarModeSlice = createSlice({
  name: "sideBarMode",
  initialState,
  reducers: {
    toggleSideBarMode: (state) => {
      if (state?.mode === "collapsed") {
        state.mode = "expanded";
        localStorage.setItem(LOCAL_STORAGE_KEYS?.SIDE_BAR_MODE, "expanded");
      } else {
        state.mode = "collapsed";
        localStorage.setItem(LOCAL_STORAGE_KEYS?.SIDE_BAR_MODE, "collapsed");
      }
    },
    resetSideBarMode: (state) => {
      state.mode = "collapsed";
      localStorage.setItem(LOCAL_STORAGE_KEYS?.SIDE_BAR_MODE, "collapsed");
    },
    openSideBarDrawer: (state) => {
      state.drawerVisibility = !state.drawerVisibility;
    },
    closeSideBarDrawer: (state) => {
      state.drawerVisibility = false;
    },
  },
});

export const {
  toggleSideBarMode,
  resetSideBarMode,
  openSideBarDrawer,
  closeSideBarDrawer,
} = sideBarModeSlice.actions;

export default sideBarModeSlice.reducer;
